import { render } from "./document-form.vue?vue&type=template&id=71759ed0"
import script from "./document-form.vue?vue&type=script&lang=js"
export * from "./document-form.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__